import React from "react";
import { useState, useEffect } from "react";
import signupimg from "../../src/assets/image.png";
import logo from "../assets/logo/Logo.png";
import google from "../assets/logo/google.png";
import facebook from "../assets/logo/facebook.png";
import apple from "../assets/logo/apple.png";
import infocircle from "../assets/info-circle.png"
import tickcircle from "../assets/tick-circle.png"
import locationicon from "../assets/gps.png"
import eye from "../assets/images/eye.png";
import eyeslash from "../assets/images/eye-slash.png";
import { Link } from "react-router-dom";
import Carousel from "../components/carousel/logincarousel";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { useNavigate } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SignupForm() {
  const navigate = useNavigate(); // Initialize navigation


  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    username: "",
    email: "",
    dob: "",
    password: "",
    confirmPassword: "",
    gender: "",
    termsAccepted: false,

    location: "",
    country: "",
    language: "",
    mobile: "",
    countryCode: "+91", // Default country code
  });
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState(""); // New error state for password validation
  const [confirmPasswordError, setConfirmPasswordError] = useState(""); // Error for confirm password
  const [isValid, setIsValid] = useState(true);  // ✅ Track form validity
 const [token, setToken] = useState("");
  const [userData, setUserData] = useState(null);
  const countryOptions = [
    { code: "US", name: "United States", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/us.png" },
    { code: "GB", name: "United Kingdom", dialCode: "+44", flagUrl: "https://flagcdn.com/w40/gb.png" },
    { code: "CA", name: "Canada", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/ca.png" },
    { code: "AU", name: "Australia", dialCode: "+61", flagUrl: "https://flagcdn.com/w40/au.png" },
    { code: "DE", name: "Germany", dialCode: "+49", flagUrl: "https://flagcdn.com/w40/de.png" },
    { code: "FR", name: "France", dialCode: "+33", flagUrl: "https://flagcdn.com/w40/fr.png" },
    { code: "JP", name: "Japan", dialCode: "+81", flagUrl: "https://flagcdn.com/w40/jp.png" },
    { code: "CN", name: "China", dialCode: "+86", flagUrl: "https://flagcdn.com/w40/cn.png" },
    { code: "IN", name: "India", dialCode: "+91", flagUrl: "https://flagcdn.com/w40/in.png" },
    { code: "BR", name: "Brazil", dialCode: "+55", flagUrl: "https://flagcdn.com/w40/br.png" },
  ];
  const [errors, setErrors] = useState({});

  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [usernameAvailable, setUsernameAvailable] = useState(null);
  const [usernameMessage, setUsernameMessage] = useState("");
  const [usernameSuggestions, setUsernameSuggestions] = useState([]);

  const [timer, setTimer] = useState(300); // 5 minutes (300 seconds)
  const [canResend, setCanResend] = useState(false);
  const [timerInterval, setTimerInterval] = useState(null); // Store interval ID
  const [termsOpened, setTermsOpened] = useState(false); // Track if terms were opened

// Load form data from sessionStorage on component mount
useEffect(() => {
  const savedFormData = sessionStorage.getItem("signupFormData");
  if (savedFormData) {
    setFormData(JSON.parse(savedFormData)); // Populate form with saved data
  }

  const termsAccepted = sessionStorage.getItem("termsAccepted");
  setTermsOpened(termsAccepted === "true"); // Check if terms were accepted
}, []);

// Format time as MM:SS
const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
};

  const checkUsernameAvailability = async (username) => {
    if (!username) {
      setUsernameAvailable(null);
      setUsernameMessage("");
      setUsernameSuggestions([]);
      return;
    }
    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/verify-username", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username }),
      });

      const data = await response.json();
      console.log("Username Check Response:", data);

      if (response.ok && data.success) {
        if (data.result.available) {
          setUsernameAvailable(true);
          setUsernameMessage("Username is available ✅");
          setUsernameSuggestions([]);
        } else {
          setUsernameAvailable(false);
          setUsernameMessage("Username is already taken ❌");
          setUsernameSuggestions(data.result.suggestions || []);
        }
      } else {
        setUsernameAvailable(null);
        setUsernameMessage("Error checking username.");
      }
    } catch (error) {
      console.error("Error:", error);
      setUsernameMessage("Network error. Try again.");
    }
  };

  // Function to get user location and convert to address
  const getLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          console.log("Coordinates:", latitude, longitude);

          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
            );
            const data = await response.json();
            console.log("Address:", data.display_name);

            setLocation(data.display_name);
            setFormData({ ...formData, location: data.display_name });
          } catch (err) {
            console.error("Error fetching address:", err);
            setError("Failed to fetch address.");
          }
        },
        (err) => {
          console.error("Geolocation Error:", err);
          setError("Location access denied. Please enable location services.");
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  const handleSubmitVerify = async (e) => {
    e.preventDefault();
    const storedEmail = sessionStorage.getItem("userEmail");
    if (!storedEmail) {
      alert("No email found. Please sign up again.");
      return;
    }
    const requestData = {
      email: storedEmail,  // Email entered by the user
      otp: code,     // Verification code entered by the user
    };

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/verify-credential", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        console.log("Verification Successful:", data);
        alert("Verification Successful! Please log in.");

        // Redirect to login page
        navigate("/login");
      } else {
        console.error("Verification Failed:", data);
        alert(`Verification failed: ${data.result?.message || "Invalid code. Please try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };


  const handleResendOTP = async (e) => {
    e.preventDefault();

    const storedEmail = sessionStorage.getItem("userEmail");

    if (!storedEmail) {
      alert("No email found. Please sign up again.");
      return;
    }

    const requestData = {
      email: storedEmail, // Email for resending OTP
    };

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/send-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      console.log("Resend OTP Response:", data);

      if (response.ok && data.success) {
        alert("OTP has been resent to your email.");
        startTimer(); // Restart the timer when OTP is resent

      } else {
        alert(`Failed to resend OTP: ${data.result?.message || "Please try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  const handleGenerateOTP = async (e) => {
    e.preventDefault();

    if (selectedMethod === "email") {
      // Send OTP to email
      const storedEmail = sessionStorage.getItem("userEmail");
      if (!storedEmail) {
        alert("No email found. Please sign up again.");
        return;
      }

      const requestData = { email: storedEmail };

      try {
        const response = await fetch("https://pipaan.com360degree.com/api/auth/send-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });

        const data = await response.json();
        if (response.ok && data.success) {
          alert("OTP has been sent to your email.");
        } else {
          alert(`Failed to send OTP: ${data.result?.message || "Please try again."}`);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong. Please try again.");
      }

    } else if (selectedMethod === "phone") {
      // Send OTP to mobile number
      const formattedMobile = `${formData.countryCode}-${formData.mobile}`;

      if (!formData.mobile) {
        alert("Please enter your mobile number.");
        return;
      }

      const requestData = { mobile_number: formattedMobile };

      try {
        const response = await fetch("https://pipaan.com360degree.com/api/auth/send-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });

        const data = await response.json();
        if (response.ok && data.success) {
          alert(`OTP has been sent to your mobile number: ${formattedMobile}`);
        } else {
          alert(`Failed to send OTP: ${data.result?.message || "Please try again."}`);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong. Please try again.");
      }
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (!code) {
      alert("Please enter the OTP.");
      return;
    }

    let requestData = {};

    if (selectedMethod === "email") {
      const storedEmail = sessionStorage.getItem("userEmail");
      if (!storedEmail) {
        alert("No email found. Please sign up again.");
        return;
      }
      requestData = { email: storedEmail, otp: code };

    } else if (selectedMethod === "phone") {
      const formattedMobile = `${formData.countryCode}-${formData.mobile}`;
      requestData = { mobile_no: formattedMobile, otp: code };
    }

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/verify-credential", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (response.ok && data.success) {
        // alert("Verification Successful! Please log in.");
  // Store access token and user data in sessionStorage
  const accessToken = data.result.token.refresh.token;
  const user = data.result.user;

  sessionStorage.setItem("accessToken", accessToken);
  sessionStorage.setItem("user", JSON.stringify(user));

  alert("Verification Successful! Redirecting to home page...");

  // Redirect to home page
  navigate("/home");
      } else {
        alert(`Verification failed: ${data.result?.message || "Invalid code. Please try again."}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };


  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "56px",
      borderRadius: "20px",
      border: "0.5px solid #095228",
      padding: "5px",
    }),
    control: (base) => ({
      ...base,
      minWidth: 100,
      minHeight: "100%",
      borderRadius: "12px",
      border: "0.5px solid #095228",
      padding: "10px 5px",
    }),
    option: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures it appears on top
  };

  // Carousel login
  let slides = [
    loginbanner,
    loginbannertwo,
    loginbannerthree,
    loginbannerfour
  ];
  let slidessm = [
    loginbannersm,
    loginbannersm,
    loginbannersm,
    loginbannersm,
  ];
  const [selectedMethod, setSelectedMethod] = useState("email"); // Default: email
  const [inputValue, setInputValue] = useState(""); // Store email or phone input

  const API_URL = "https://pipaan.com360degree.com/api/auth";
  // ✅ Handle Google Login
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/google`;
  };

  const fetchUserProfile = async () => {
    const token = sessionStorage.getItem("accessToken"); // Retrieve token
    console.log("Retrieved Token in home page:", token); // ✅ Log token to verify

    if (!token) {
      console.log("Token not found, waiting...");
      setError("Authentication token not found!");
      return;
    }

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/user/profile", {
        method: "GET",
        headers: {
          "token": `${token}`, // ✅ Ensure proper format
          "Content-Type": "application/json"
        }
      });

      console.log("API Response Status:", response.status); // ✅ Log status
      if (!response.ok) {
        const errorData = await response.json();
        console.error("❌ API Error Data:", errorData);
        setError(errorData.message || "Failed to fetch user profile");
        return;
      }

      const data = await response.json();
      console.log("✅ API Success Response from profile page:", data); // ✅ Log full response
      setUserData(data.result)
      sessionStorage.setItem("user", JSON.stringify(data.result)); // Store user in sessionStorage
    } catch (err) {
      console.error("❌ Fetch API Error:", err);
      setError("An error occurred while fetching the profile");
    }
  };
  useEffect(() => {
    // ✅ Parse URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const success = urlParams.get("success");
    const token = urlParams.get("token");
    // const user = urlParams.get("user");

    console.log("Google Login Response:", { success, token });

    if (success === "true" && token) {
      setToken(token)
      sessionStorage.setItem("accessToken", token);

      // sessionStorage.setItem("user", decodeURIComponent(user));
      fetchUserProfile()
      // console.log("User Data:", decodeURIComponent(user));
      if (sessionStorage.getItem("user")) {
        navigate("/home")
      }

    } else {
      console.error("Google Login Failed");
      // navigate("/");
    }
  }, [userData]);

  // ✅ Handle Facebook Login
  const handleFacebookLogin = () => {
    window.location.href = `${API_URL}/facebook`;
  };
  const [passwordMatchError, setPasswordMatchError] = useState("")
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleOTPChange = (index, value) => {
    if (value.length > 1) return;
    const newOTP = [...formData.otp];
    newOTP[index] = value;
    setFormData({ ...formData, otp: newOTP });
  };
  const [suggestions, setSuggestions] = useState([]);

  const generateSuggestions = (input) => {
    if (!input) return []; // No suggestions if input is empty
    return [
      `@${input}_001`,
      `@${input}_05`,
      `@${input}_99`,
    ];
  };
  const [passwordCriteria, setPasswordCriteria] = useState({
    minLength: false,
    alphanumeric: false,
    specialChar: false,
  });
  const validatePassword = (password) => {
    setPasswordCriteria({
      minLength: password.length >= 8,
      alphanumeric: /[a-zA-Z]/.test(password) && /[0-9]/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };


  // ✅ Validate Confirm Password on Input
  const validateConfirmPassword = (value) => {
    if (!value) {
      setConfirmPasswordError("Confirm password is required.");
    } else if (value !== password) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError(""); // Clear error if valid
    }
    setConfirmPassword(value);
  };

  const languages = ["English", "Spanish", "French", "German", "Chinese"];
  const countries = ["India", "USA", "France", "Germany", "China"];
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otp, setOtp] = useState("");


  // Function to start the timer
const startTimer = () => {
  setTimer(300); // Reset timer to 5 minutes
  setCanResend(false); // Disable resend button
  if (timerInterval) clearInterval(timerInterval); // Clear any existing interval

  const interval = setInterval(() => {
    setTimer((prev) => {
      if (prev <= 1) {
        clearInterval(interval); // Stop timer when it reaches 0
        setCanResend(true); // Enable resend button
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  setTimerInterval(interval); // Store interval ID
};
 // Call startTimer when OTP modal is opened
useEffect(() => {
  if (showOTPModal) {
    startTimer(); // Start timer when OTP modal is shown
  }
}, [showOTPModal]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));

    validateDOB(value);

    // Clear errors when user starts typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    // Username availability check
    if (name === "username") {
      checkUsernameAvailability(value);
    }

    // Password validation
    if (name === "password") {
      validatePassword(value);
    }

    // Confirm Password validation
    if (name === "confirmPassword") {
      checkPasswordMatch(value);
    }

    // Additional Validations
    if (name === "firstname" && !value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, firstname: "First name is required" }));
    }

    if (name === "lastname" && !value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, lastname: "Last name is required" }));
    }

    if (name === "email" && !value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "Email is required" }));
    }

    if (name === "dob" && !value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, dob: "Date of birth is required" }));
    }

    if (name === "gender" && !value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, gender: "Please select your gender" }));
    }

    if (name === "mobile" && !value.trim()) {
      setErrors((prevErrors) => ({ ...prevErrors, mobile: "Mobile number is required" }));
    }

    if (name === "termsAccepted" && !checked) {
      setErrors((prevErrors) => ({ ...prevErrors, termsAccepted: "You must accept the Terms & Conditions" }));
    }
  };


 // Calculate the maximum allowable date (13 years before today)
const today = new Date();
const minAllowedDate = new Date();
minAllowedDate.setFullYear(today.getFullYear() - 13); // Subtract 13 years
const maxDOB = minAllowedDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

  const validateDOB = (dob) => {
    const selectedDate = new Date(dob);
    const todayDate = new Date();
    minAllowedDate.setFullYear(today.getFullYear() - 13); // Subtract 13 years
    const maxDOB = minAllowedDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

    if (!dob) {
      setErrors((prev) => ({ ...prev, dob: "Date of birth is required." }));
      setIsValid(false);
    } else if (selectedDate > todayDate) {
      setErrors((prev) => ({ ...prev, dob: "Date of birth is required." }));
      setIsValid(false);
    } else if (selectedDate > minAllowedDate) {
      setErrors((prev) => ({ ...prev, dob: "You must be at least 13 years old to register." }));
      setIsValid(false);
    } else {
      setErrors((prev) => ({ ...prev, dob: "" })); // Clear error if valid
      setIsValid(true);
    }
  };

  // Function to check if passwords match
  const checkPasswordMatch = (confirmPassword) => {
    if (confirmPassword !== formData.password) {
      setPasswordMatchError("Passwords do not match!");
    } else {
      setPasswordMatchError(""); // Clear error if passwords match
    }
  };
  const handleSuggestionClick = (suggestion) => {
    setFormData({ ...formData, username: suggestion });
    setSuggestions([]); // Hide suggestions after selection
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
     // Check if terms were opened
     if (!termsOpened) {
      alert("You must read and accept the Terms & Conditions before creating an account.");
      return;
    }
    let newErrors = {};
    // ✅ Password criteria validation before submission
    if (!passwordCriteria.minLength || !passwordCriteria.alphanumeric || !passwordCriteria.specialChar) {
      newErrors.password = "Password must meet the criteria: Minimum 8 characters, alphanumeric, and at least one special character.";
      setErrors(newErrors);

      // Display error and prevent submission
      toast.error("⚠️ Password must meet the criteria: Minimum 8 characters, alphanumeric, and at least one special character.", {
        position: "top-right",
        autoClose: 3000,
        style: { backgroundColor: "#ff4d4f", color: "#fff", fontWeight: "bold" }
      });
      return;
    }

    // ✅ Proceed with form submission if no password errors
    if (Object.keys(newErrors).length > 0) {
      toast.error("⚠️ Please fill in all required fields correctly!", {
        position: "top-right",
        autoClose: 3000,
        style: { backgroundColor: "#ff4d4f", color: "#fff", fontWeight: "bold" }
      });
      return;
    }

    // ✅ Validate Date of Birth before proceeding
    const today = new Date();
    const dobDate = new Date(formData.dob);
    const minAllowedDate = new Date();
    minAllowedDate.setFullYear(today.getFullYear() - 13);  // Minimum age is 13 years

    // ✅ Check for future dates or under 13 years old
    if (!formData.dob.trim()) {
      newErrors.dob = "Date of birth is required.";
    } else if (dobDate > today) {
      newErrors.dob = "Future dates are not allowed.";
    } else if (dobDate > minAllowedDate) {
      newErrors.dob = "You must be at least 13 years old to register.";
      // ✅ Show both toast and alert for under 13 users
      alert("❌ You must be at least 13 years old to create an account.");
      toast.error("⚠️ You must be at least 13 years old to register.", {
        position: "top-right",
        autoClose: 3000,
        style: { backgroundColor: "#ff4d4f", color: "#fff", fontWeight: "bold" }
      });
    }
    // Validate all fields
    if (!formData.firstname.trim()) newErrors.firstname = "First name is required";
    if (!formData.lastname.trim()) newErrors.lastname = "Last name is required";
    if (!formData.username.trim()) newErrors.username = "Username is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.gender.trim()) newErrors.gender = "Please select your gender";
    if (!formData.location.trim()) newErrors.location = "Please select your location";
    if (!formData.country.trim()) newErrors.country = "Please select your country";
    if (!formData.language.trim()) newErrors.language = "Please select your language";

    if (!formData.password.trim()) newErrors.password = "Password is required";
    if (formData.password.length < 8) newErrors.password = "Password must be at least 8 characters";
    if (!formData.confirmPassword.trim()) newErrors.confirmPassword = "Confirm  password should be same as password ";
    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    if (!formData.termsAccepted) newErrors.termsAccepted = "You must accept the Terms & Conditions";

    setErrors(newErrors);

    // If there are errors, prevent submission
    // If there are errors, prevent submission
    if (Object.keys(newErrors).length > 0) {
      toast.error("⚠️ Please fill in all required fields correctly!", {
        position: "top-right",
        autoClose: 3000,
        style: { backgroundColor: "#ff4d4f", color: "#fff", fontWeight: "bold" }
      }); return;
    }
    // ✅ Final DOB check before submission
    if (newErrors.dob) {
      toast.error(newErrors.dob, {
        position: "top-right",
        autoClose: 3000,
        style: { backgroundColor: "#ff4d4f", color: "#fff", fontWeight: "bold" }
      });
      console.log("Form submission blocked due to invalid DOB.");
      return;  // Prevent submission
    }

    const formattedMobile = `${formData.countryCode}-${formData.mobile}`;

     // Check if terms are accepted
     const termsAccepted = sessionStorage.getItem("termsAccepted");
     if (termsAccepted !== "true") {
       alert("You must accept the Terms & Conditions before creating an account.");
       return;
     }
    // Construct the request body
    const requestData = {
      username: formData.username,
      email: formData.email,
      first_name: formData.firstname,
      last_name: formData.lastname,
      date_of_birth: formData.dob,
      mobile_number: formattedMobile, // Combine country code and number
      gender: formData.gender,
      location: formData.location,
      country: formData.country,
      language: formData.language,
      role: 1, // Assuming a default role
      is_tc_agreed: formData.termsAccepted,
      password: formData.password,
      // terms_url: "https://pipaan.com/terms-conditions", // URL of the terms

      // verification: formData.verification// Convert OTP array to string
    };

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/auth/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setShowOTPModal(true);

        console.log("Registration Successful:", data);
        alert("Registration Successful!");
        sessionStorage.removeItem("signupFormData"); // Clear saved form data

        sessionStorage.removeItem("termsAccepted"); // Clear terms acceptance

        console.log("User Data:", data.result.data);
        // Redirect or update UI if needed
        // Store email or user details for verification
        sessionStorage.setItem("userEmail", formData.email);

        // Redirect to verification page
        // navigate("/verifycodeforsignup"); 

      } else {
        console.error("Registration Failed:", data);
        alert(`Email ID or mobile number is already registered: ${data.result?.message || "Try with another email or mobile number"}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleCountryChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      countryCode: selectedOption.dialCode, // Update the country code
    }));
  };
  const handleTermsClick = () => {
    // Navigate to the Terms & Conditions page
    sessionStorage.setItem("signupFormData", JSON.stringify(formData));

    navigate("/terms-conditions");
  };
  return (
    <div className="login">
      <div className="container mx-auto flex">
        {/* Left side image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3 ">
            <Carousel slides={slides} />
            {/* <!-- Overlay Image --> */}
            <img src={bannerlayout} alt="Overlay" class="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>

        {/* Right side login form */}
        <div className=" w-full lg:w-1/2 login-content flex flex-col">
          <div className="carousel-d-none-sm md:block lg:hidden ">
            <div className="carousel-size pb-3 pt-3 ">
              <Carousel slides={slides} />
              {/* <!-- Overlay Image --> */}
              <img src={bannerlayout} alt="Overlay" class="layout" />
            </div>
          </div>
          <div className="lg:hidden md:hidden">
            <div className="carousel-size pb-3 pt-3 ">
              <Carousel slides={slidessm} />
              {/* <!-- Overlay Image --> */}
              <img src={bannerlayout} alt="Overlay" class="layout" />
            </div>
          </div>
          <div className="login-form signup-form">
            {/* Language selector */}
            <div className="flex justify-end ">

              <Menu as="div" className="language-btn relative inline-block text-left">
                <div>
                  <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm align-center  hover:bg-gray-50">
                    English
                    <svg width="10" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.92 0.179932H6.68999H1.07999C0.119992 0.179932 -0.360007 1.33993 0.319993 2.01993L5.49999 7.19993C6.32999 8.02993 7.67999 8.02993 8.50999 7.19993L10.48 5.22993L13.69 2.01993C14.36 1.33993 13.88 0.179932 12.92 0.179932Z" fill="#292D32" />
                    </svg>
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <form action="#" method="POST">
                      <MenuItem>
                        <button
                          type="submit"
                          className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                        >
                        </button>
                      </MenuItem>
                    </form>
                  </div>
                </MenuItems>
              </Menu>
            </div>


            {/* Main content */}
            <div className="mobile-ver flex-1 flex flex-col items-center justify-center max-w-[440px] mx-auto w-full">
              {/* Logo */}
              <div className="mb-8">
                <img
                  src={logo}
                  alt="Pipaan Logo"
                  width={150}
                  height={50}
                />
              </div>
              {/* Login form */}
              <div className="w-full space-y-6 ">
                <h1 className="text-3xl font-semibold font-semibold  text-center">
                  Get Started
                </h1>
                <h1 className="text-center">
                  <span className="text-gray-600">Welcome to </span> <span className="text-black">Pipaan</span> - <span className="text-gray-600">Lets Create your Account</span>
                </h1>
                <div className="grid grid-cols-3 gap-4">
                  <button className="w-full rounded-lg"  onClick={handleGoogleLogin}>
                    <img
                      src={google}
                      alt="Google"
                      className=" mx-auto"
                    />
                  </button>
                  <button className="w-full rounded-lg " onClick={handleFacebookLogin}>
                    <img
                      src={facebook}
                      alt="Facebook"
                      className=" mx-auto"
                    />
                  </button>
                  {/* <button className="w-full rounded-lg">
                    <img
                      src={apple}
                      alt="Apple"
                      className=" mx-auto"
                    />
                  </button> */}
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="bg-white px-2 text-gray-500">
                    Or
                  </span>
                </div>
                <div className="space-y-4 signup-scroll">
                  <div className="space-y-2" >
                    <label className="text-sm font-medium  -top-[35px] " htmlFor="firstname">
                      First Name
                    </label>
                    <input
                      id="fulfirstnamelname"
                      placeholder="Enter your First Name"
                      type="text"
                      name="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                      className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    {errors.firstname && <p className="text-red-500 text-sm">{errors.firstname}</p>}

                  </div>
                  <div className="space-y-2" >
                    <label className="text-sm font-medium" htmlFor="lastname">
                      Last Name
                    </label>
                    <input
                      id="lastname"
                      placeholder="Enter your Last Name"
                      type="text"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                      className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    {errors.lastname && <p className="text-red-500 text-sm">{errors.lastname}</p>}

                  </div>
                  <div className="space-y-2 relative">
                    <label className="text-sm font-medium" htmlFor="username">
                      User Name
                    </label>
                    <div className="relative">
                      <input
                        id="username"
                        placeholder="Enter your User Name"
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 pr-10"
                      />

                      {/* Success or Error Icon */}
                      {usernameAvailable === true && (
                        <img src={tickcircle} alt="Available" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-6" />
                      )}
                      {usernameAvailable === false && (
                        <img src={infocircle} alt="Taken" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-6" />
                      )}
                    </div>
                    {/* Show Username Validation Message */}
                    {usernameMessage && (
                      <p className={`text-sm ${usernameAvailable ? "text-green-500" : "text-red-500"}`}>
                        {usernameMessage}
                      </p>
                    )}
                    {/* Show Suggestions if Username is Taken */}
                    {usernameSuggestions.length > 0 && (
                      <div className="suggestion pt-2 pb-4 flex items-center">
                        <p className="title-suggestion">Suggestions:</p>
                        <ul className="flex space-x-4 text-blue-600 font-medium underline">
                          {usernameSuggestions.map((suggestion, index) => (
                            <li
                              key={index}
                              className="cursor-pointer hover:underline"
                              onClick={() => setFormData({ ...formData, username: suggestion })}
                            >
                              {suggestion}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {errors.username && <p className="text-red-500 text-sm">{errors.username}</p>}

                  </div>
                  <div className="space-y-2" >
                    <label className="text-sm font-medium" htmlFor="dob">
                      Date of Birth
                    </label>
                    <input
                      id="dob"
                      placeholder="DD/MM/YY"
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      onClick={() => validateDOB(formData.dob)}  // ✅ Real-time validation on click
                      max={maxDOB}               // Disable future dates
                      // min="1900-01-01"   
                      className={`w-[400px] h-[60px] px-3 py-2 border ${errors.dob ? "border-red-500" : "border-gray-400"
                        } rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200`}
                    />
                    {errors.dob && <p className="text-red-500 text-sm">{errors.dob}</p>}

                  </div>
                  <div className="space-y-2 relative">
                    <div>
                      <label className="text-sm font-medium" htmlFor="gender">
                        Gender</label>
                    </div>
                    <select
                      name="gender"
                      className=" h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                      onChange={handleChange}
                      value={formData.gender}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Others">Prefer not to say</option>
                    </select>
                    {errors.gender && <p className="text-red-500 text-sm">{errors.gender}</p>}
                  </div>
                  <div className="flex flex-col space-y-2">
                    <label className="text-sm font-medium" htmlFor="email">
                      Email
                    </label>
                    <input
                      id="email"
                      name="email"
                      placeholder="Enter your E Mail ID"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    {errors.email && <p className=" error-message text-red-500 text-sm">{errors.email}</p>}

                  </div>

                  <div className="space-y-2 relative">
                    <label className="text-sm font-medium" htmlFor="password">
                      Password
                    </label>
                    <div className="relative">
                      <input
                        id="password"
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 pr-16"
                      />
                      
                      {/* Show/Hide Password Toggle */}
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10"
                      >
                        <img
                          src={showPassword ? eye : eyeslash}
                          alt="Toggle Password"
                          className="w-6 h-6"
                        />          </button>
                      {/* Green Checkmark inside the field when all criteria match */}
                      {passwordCriteria.minLength &&
                        passwordCriteria.alphanumeric &&
                        passwordCriteria.specialChar && (
                          <img
                            src={tickcircle}  // Replace with the actual path to your checkmark image
                            alt="Green Checkmark"
                            className="absolute right-11 top-1/2 transform -translate-y-1/2 w-6 h-6 z-20"
                          />
                        )}
                    </div>
                    {errors.password && <p className=" error-message text-red-500 text-sm">{errors.password}</p>}
                    {/* Password Criteria */}
                    <div className="password-checkmar text-sm text-gray-600 mt-2 flex flex-wrap gap-x-6">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          checked={passwordCriteria.minLength}
                          readOnly
                          className="w-4 h-4 accent-green-500"
                        />
                        <span>Min 8 characters</span>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          checked={passwordCriteria.alphanumeric}
                          readOnly
                          className="w-4 h-4 accent-green-500"
                        />
                        <span>Alphanumeric</span>              </div>
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          checked={passwordCriteria.specialChar}
                          readOnly
                          className="w-4 h-4 accent-green-500"
                        />
                        <span>Special character</span>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-2 relative">
                    <label className="text-sm font-medium" htmlFor="confirmpassword">
                      Confirm Password
                    </label>
                    <div className="relative ">
                      <input
                        id="confirmpassword"
                        placeholder="Enter your password"
                        type={showConfirmPassword ? "text" : "password"}

                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 pr-16"
                      />
                      {errors.confirmPassword && <p className=" error-message text-red-500 text-sm">{errors.confirmPassword}</p>}

                      {/* Show/Hide Confirm Password Toggle */}
                      <button
                        type="button"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10"
                      >
                        <img
                          src={showConfirmPassword ? eye : eyeslash}
                          alt="Toggle Password"
                          className="w-6 h-6"
                        />
                      </button>
                      {/* Green Checkmark when passwords match */}
                      {formData.confirmPassword &&
                        formData.confirmPassword === formData.password && (
                          <img
                            src={tickcircle}  // Update path to match your actual checkmark image location
                            alt="Password Match"
                            className="absolute right-11 top-1/2 transform -translate-y-1/2 w-6 h-6 z-20"
                          />
                        )}
                    </div>
                    {/* Show error message if passwords don't match */}
                    {passwordMatchError && (
                      <p className="text-red-500 text-sm">{passwordMatchError}</p>
                    )}
                  </div>
                  <div className="location space-y-2 relative">
                    <label className="text-sm font-medium" htmlFor="location">
                      Location
                    </label>
                    <input
                      id="location"
                      placeholder="Add your Location"
                      type="location"
                      name="location"
                      value={formData.location || location}
                      // onChange={handleChange}
                      onClick={getLocation}
                      readOnly
                      className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                    />

                    {/* Location Icon Inside the Field */}
                    <img
                      src={locationicon} // Make sure to use the correct image path
                      alt="Location"
                      className="  transform -translate-y-1/2 w-6 h-6"
                    />

                  </div>
                  {errors.location && <p className="text-red-500 text-sm">{errors.location}</p>}

                  <div className="space-y-2 relative">
                    <div>
                      <label className="text-sm font-medium" htmlFor="country">
                        Country Of Origin</label>
                    </div>
                    <select
                      name="country"
                      className=" h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                      onChange={handleChange}
                      value={formData.country}
                      required
                    >
                      <option value="">Select Your Country</option>
                      {countries.map((lang) => (
                        <option key={lang} value={lang}>
                          {lang}
                        </option>
                      ))}
                    </select>
                    {errors.country && <p className="text-red-500 text-sm">{errors.country}</p>}

                  </div>
                  <div className="space-y-2">
                    <div>
                      <label className="text-sm font-medium" htmlFor="location">
                        Language</label>
                    </div>
                    <select
                      name="language"
                      className="h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                      onChange={handleChange}
                      value={formData.language}
                      required
                    >
                      <option value="">Select your Language</option>
                      {languages.map((lang) => (
                        <option key={lang} value={lang}>
                          {lang}
                        </option>
                      ))}
                    </select>
                    {errors.language && <p className="text-red-500 text-sm">{errors.language}</p>}

                  </div>

                  {/* Phone Number Input */}
                  <div className="space-y-2">
                    <label className="text-sm font-medium" htmlFor="mobile">
                      Mobile Number
                    </label>
                    <div className="flex space-x-2 items-center">
                      <Select
                        options={countryOptions}
                        getOptionLabel={(e) => (
                          <div className="flex items-center">
                            <img src={e.flagUrl} alt="" className="w-6 h-4" />
                            <span className="ml-2 hidden">{e.dialCode}</span>
                          </div>
                        )}
                        getOptionValue={(e) => e.dialCode}
                        value={countryOptions.find((c) => c.dialCode === formData.countryCode)}
                        onChange={handleCountryChange}
                        styles={customStyles}
                        menuPortalTarget={document.body} // Ensures popup behavior
                        menuPosition="absolute"
                      />

                      <input
                        id="mobile"
                        placeholder="Phone Number"
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="w-[300px] h-[56px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200"
                      />

                    </div>


                  </div>

                  {errors.mobile && <p className="text-red-500 text-sm">{errors.mobile}</p>}

                </div>
                <div className="agree-terms flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="termsAccepted"
                      id="termsAccepted"
                      checked={formData.termsAccepted}
                      onChange={handleChange}
                      className="w-4 h-4 text-blue-600 border-gray-300 rounded-full focus:ring-blue-500"
                    />
                    <label
                      htmlFor="termsAccepted"
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      By signing up you agree to our{" "}
                      <span className="text-[#006838] underline"               onClick={handleTermsClick} // Navigate to Terms & Conditions page
                      >Terms & Conditions</span>
                    </label>

                  </div>

                </div>
                {errors.termsAccepted && <p className="text-red-500 text-sm">{errors.termsAccepted}</p>}

                <div className="text-center">
                  <button
                    onClick={handleSubmit}
                    className="creat-account-cta w-[100%] h-[56px] bg-[#1B2537] hover:bg-[#1B2537]/90 text-white py-3 rounded-lg"
                  >
                    Create Account
                  </button>

                  {/* OTP Modal */}
                  {showOTPModal && (
                    <div className="fixed inset-0 flex items-center justify-center  bg-[#fff] backdrop-blur bg-opacity-50">
                      <div className="bg-white p-6  md:pl-[5%] md:pr-[5%] md:pb-[3%] rounded-lg shadow-lg relative">
                        {/* Close Button */}
                        <button
                          className="hidden md:block absolute top-2 right-2 text-[#fff] hover:text-[#fff] bg-[#095228] rounded-full p-1 pl-2.5 pr-2.5"
                          onClick={() => setShowOTPModal(false)}
                        >
                          ✖
                        </button>

                        {/* Forgot Password Form */}
                        <h2 className="login-title text-base font-medium text-center mt-2 mb-6 ">
                          OTP Verification
                        </h2>

                        <form onSubmit={handleSubmitVerify} className="space-y-4 frg-pass-content">
                          {/* Radio Buttons for Selection */}
                          <div className="flex justify-around space-x-4 mb-4">
                            <label className="flex items-center space-x-2 cursor-pointer">
                              <input
                                type="radio"
                                name="recoveryMethod"
                                value="email"
                                checked={selectedMethod === "email"}
                                onChange={() => setSelectedMethod("email")}
                                className="w-4 h-4 border-[#095228] rounded-full focus:ring-green-500"
                              />
                              <span className="text-base text-[#344054]">Email</span>
                            </label>

                            <label className="flex items-center space-x-2 cursor-pointer">
                              <input
                                type="radio"
                                name="recoveryMethod"
                                value="phone"
                                checked={selectedMethod === "phone"}
                                onChange={() => setSelectedMethod("phone")}
                                className="w-4 h-4"
                              />
                              <span className="text-base text-[#344054]">Phone No</span>
                            </label>
                          </div>
                          <button
                            type="submit"
                            onClick={handleGenerateOTP} // Call function to send OTP

                            className="w-full bg-[#1B2537] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl font-medium"
                          >
                            Generate OTP
                          </button>
                          {/* Conditional Input Field */}
                          <div>
                            <label className="text-[12px] text-[#80807F] font-small block mt-9 mb-2">Enter the verification code we just sent to your&nbsp;
                              {selectedMethod === "email" ? "Email" : "Phone Number"}
                            </label>
                            <input
                              // type={selectedMethod === "email" ? "email" : "tel"}
                              placeholder={selectedMethod === "email" ? "Enter Verification Code" : "Enter Verification Code"}
                              value={code}
                              onChange={(e) => setCode(e.target.value)}
                              className="mb-4 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 outline-none"
                              required
                            />
                          </div>

                          {/* Signup Link */}
                          <div className="vrfy-code-valid ">
                            {/* <num className="timer">05.00</num> */}
                            <p className="text-lg font-bold text-red-500">{formatTime(timer)}</p>

                          </div>
                          <p className=" text-center text-sm text-gray-600 ">
                            Didn’t receive a code?{" "}
                            {/* <Link to="/signup" className="text-[#095228] font-medium hover:underline">
                              Resend
                            </Link> */}
                            <button
                              onClick={handleResendOTP} // Call new function to resend OTP
                              className="text-[#095228] font-medium hover:underline"
                            >
                              Resend
                            </button>
                          </p>
                          <button
                            type="submit"
                            onClick={handleVerifyOTP} // Call function to verify OTP

                            className="w-full bg-[#80807F] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl font-medium mb-10"
                          >
                            Verify
                          </button>
                          {/* Close Button */}
                          <button
                            className="md:hidden w-full bg-[#161F28] hover:bg-[#1B2537]/90 text-white py-3 rounded-xl font-medium mb-10"
                            onClick={() => setShowOTPModal(false)}
                          >
                            Cancel
                          </button>
                        </form>
                      </div>
                    </div>
                  )}
                </div>

                {/* <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                </div> */}
                <p className="text-center text-sm text-[#3A3A3C]">
                  Already have an account? {" "}
                  <a
                    href="/login"
                    className="text-[#006838] hover:underline font-medium"
                  >               Log in
                  </a>
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}




